export default __webpack_public_path__ + "static/media/supportEng.e3e88c66.jpg";